"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentation = exports.name = void 0;
exports.implementation = implementation;
const uuid_1 = require("uuid");
const constants_1 = require("./constants");
exports.name = "uuid";
function implementation() {
    return (0, uuid_1.v4)();
}
exports.documentation = {
    label: "$uuid",
    detail: "$uuid()",
    documentation: `Create a version 4 (random) UUID.
${constants_1.STEDI_FUNCTION_DISCLAIMER}

**Example**

| Expression | Result                                 |
|------------|----------------------------------------|
| $uuid()    | "1a28e35f-d420-4b95-ad09-1bb4b39821dc" |`,
    insertText: "\\$uuid()",
    parameters: [],
};
